import { createFileRoute, redirect } from '@tanstack/react-router';
import { Pane } from '@sheridan-prize/ui';
import { SpSidebar } from '../components/Sidebar';
import { getAuthStore } from '../main';
import { AccountHeader } from '../components/AccountHeader';
import { ViewArtAppFetchWrapper } from '../components/ViewArtAppFetchWrapper';

export const Route = createFileRoute('/view-artwork')({
  beforeLoad: async () => {
    await getAuthStore().fetchUser();

    const isAuthenticated = getAuthStore().getIsAuthenticated();
    if (!isAuthenticated) {
      throw redirect({ to: '/login' });
    }
  },
  component: ViewArtwork,
});

function ViewArtwork() {
  const userRole = getAuthStore().getUser()?.role;

  return (
    <>
      <AccountHeader />
      <div className="app">
        <SpSidebar />
        <Pane classes={'sp-main'} tag="main">
          <h1>View All of the Artwork for 2025</h1>
          <ViewArtAppFetchWrapper
            isAccount={true}
            initialCategory="all"
            userRole={userRole}
          />
        </Pane>
      </div>
    </>
  );
}
